import React, { Component } from "react";
import axios from "axios";
import qs from "qs";
import debounce from "lodash/debounce";
import isEmpty from "lodash/isEmpty";

// State
import { REACT_APP_API_URL, REACT_APP_SITE_KEY } from "../../../../shared/vars";

class CustomerSearch extends Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			q: "",
			error: {},
			canSearch: false,
			customers: []
		};

	}

	handleKeyPress(event) {
		if (event.key === "Enter") {
			event.preventDefault();
			
			this.performSearch();
		}
	}

	handleKeyPressDebouncer = debounce(function(value) {
		this.performSearch();
	});

	handleInputChange(event) {
		const { value } = event.target;
		this.setState(
			{
				...this.state,
				canSearch: true,
				q: value
			},
			this.handleKeyPressDebouncer(value)
		);
	}

	performSearch() {
		const { q, canSearch } = this.state;
		const { currentlySelected, topTierId } = this.props;

		// If nothing has changed in the search term, do nothing
		if (!canSearch) return;

		// If the query string is empty, set empty collection
		if (q === "") {
			this.setState({
				canSearch: false,
				customers: []
			});
			return;
		}

		const selectionIds = currentlySelected.map(item => {
			return item.id;
		});

		this.setState({ canSearch: false });

		// Put querystring data together
		const data = qs.stringify(
			{
				q,
				currentlySelected: selectionIds,
				topTierId: topTierId
			},
			{ arrayFormat: ["brackets"] }
		);

		this.setState({
			isLoading: true
		}, () => {
			// Make ajax call
			const AUTH_HEADER = { Authorization: REACT_APP_SITE_KEY };
			return axios
				.get(REACT_APP_API_URL + "customer-list?" + data, { headers: AUTH_HEADER })
				.then(response => {
					if (response.status !== 200 || (response.data.status && response.data.status !== 200)) {
						this.setState({ isLoading: false, error: response.data.message, customers: [], visible: false });
					} else {
						this.setState({ isLoading: false, customers: !!response.data.customers ? response.data.customers : [], visible: true });
					}
				})
				.catch(err => {
					if (err.response) {
						this.setState({ isLoading: false, error: err.response.data.errors ? err.response.data.errors : err.response.data.message, customers: [], visible: false });
					} else {
						this.setState({ isLoading: false, error: err.message, customers: [], visible: false });
					}
				});
		})
	}

	// Called as a ref from parent class AdminTopTiers
	resetSearch = () => {
		this.setState({ 
			q: "",
			canSearch: false,
			customers: []
		}, () => this.performSearch())
	}

	render() {
		const { q, customers, isLoading } = this.state;
		const { currentlySelected } = this.props;
		
		return (
			<div className="customer-search-table">
				<div className="customer-search-label">Available Customers:</div>
				<div className="ajax-search-wrapper">
					<div className={`input-placeholder-wrapper placeholder--search-field ${this.props.disabled ? 'disabled' : ''}`}>
						<span className="placeholder icon-search" />
						<input type="text" value={q} placeholder="Search customers" onChange={e => this.handleInputChange(e)} disabled={this.props.disabled}/>
					</div>
				</div>
				<table>
					<thead>
						<tr>
							<td>#</td>
							<td>Name</td>
							<td>Email</td>
							<td>Add</td>
						</tr>
					</thead>
					<tbody>
						{isEmpty(q) && 
						<tr>
							<td colSpan="4" style={{fontStyle: 'italic'}}>Type in the box to search for customers.</td>
						</tr>}
						{isEmpty(customers) && !isEmpty(q) && !isLoading ?
						<tr>
							<td colSpan="4" style={{fontStyle: 'italic'}}>No search results found.</td>
						</tr>
						:
						customers.map((item, i) => {
							let selected = false;
							if(currentlySelected.length && currentlySelected.find(selected => selected.id === item.id))
								selected = true;
							
							return (
								<tr key={i}>
									<td>{i + 1}</td>
									<td>{item.fname + " " + item.lname}</td>
									<td>{item.email}</td>
									<td><button className={selected ? 'icon-star-full' : 'icon-star-empty'} disabled={selected} onClick={() => this.props.addCustomer(item)}></button></td>
								</tr>
							)
						})}
					</tbody>
				</table>
			</div>
		);
	}
}

export default CustomerSearch;



// WEBPACK FOOTER //
// ./src/components/admin/top-tiers/customers/CustomerSearch.js